import { Enums } from '@intelipost-js/secure-providers';

const PageManualDispatch = () => import('./PageManualDispatch');
const PageManagerDispatch = () => import('./manager/PageManagerDispatch');

export default {
  path: 'manual-dispatch',
  children: [
    {
      path: '',
      name: 'manual-dispatch-start',
      component: PageManualDispatch,
      meta: {
        screenMode: Enums.ScreenModes.SIMPLE,
        title: 'Despacho Manual',
      },
    },
    {
      path: 'manager/:id?',
      name: 'manual-dispatch-manager',
      component: PageManagerDispatch,
      meta: {
        screenMode: Enums.ScreenModes.SIMPLE,
        title: 'PLP: {{id}} - Despacho Manual',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-psl/features/manual-dispatch/routes.js